import BoldText from '@/components/BoldText';
import MediumText from '@/components/MediumText';
import { PATH } from '@/constants/path';
import { openCrisp } from '@/helpers';
import { apiCaller } from '@/redux/query';
import { isSkipApiSelector } from '@/redux/slice/auth.slice';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { Badge, Button, Card, Icon, Link, SkeletonBodyText } from '@shopify/polaris';
import { CheckCircleIcon, XCircleIcon } from '@shopify/polaris-icons';
import { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function EmbedApp() {
  const navigate = useNavigate();
  const dataSettings = useSelector(dataSettingsSelector);
  const isSkip = useSelector(isSkipApiSelector);
  const [getEmbeddedStatus, { isLoading }] = apiCaller.useLazyGetEmbeddedAppStatusQuery();
  const [state, setState] = useState({
    isShow: false,
    isEmbedded: false,
    isCalledEmbed: false,
  });

  useEffect(() => {
    const handleGetEmbeddedStatus = async () => {
      try {
        const res = await getEmbeddedStatus();
        if (res.data) {
          setState({ isShow: true, isEmbedded: res?.data?.data?.disabled, isCalledEmbed: true });
        }
      } catch (error) {
        console.log(error);
      }
    };
    if (!isSkip && !state.isCalledEmbed) {
      handleGetEmbeddedStatus();
    }
  }, [getEmbeddedStatus, isSkip, state.isCalledEmbed]);

  return state.isShow && !isLoading ? (
    <Card>
      <div className="w-full">
        <div className="content-between align-center">
          <div className="d-flex">
            {!state.isEmbedded ? <Icon source={XCircleIcon} tone="warning" /> : <Icon source={CheckCircleIcon} tone="success" />}
            <div className="ml-8">
              <BoldText>Embed app on store</BoldText>
            </div>
            {!state.isEmbedded ? (
              <div className="ml-8">
                <Badge tone="attention">Action required</Badge>
              </div>
            ) : null}
          </div>
          {!state.isEmbedded ? (
            <div>
              <Button
                onClick={() => {
                  window.open(
                    `https://${dataSettings.shop}.myshopline.com/admin/theme/editor/editing/ProductsDetail?themeId=${dataSettings.themeStoreId}&templateName=templates/product.json&activateAppId=${process.env.REACT_APP_THEME_APP_EXTENSION_ID}/app-embed-block`,
                    '_blank',
                  );
                }}
                variant="primary"
                loading={isLoading}
              >
                Embed app
              </Button>
            </div>
          ) : null}
        </div>
        {!state.isEmbedded ? (
          <>
            <div className="text-embed mt-8">
              <MediumText>
                You can also add block or custom HTML.{' '}
                <Link
                  onClick={() => {
                    navigate(PATH.DISPLAY_POSITION, { state: { isHighlight: true } });
                  }}
                >
                  See more
                </Link>
              </MediumText>
            </div>
            <MediumText>If app banner is already displayed on store, just skip this step.</MediumText>
          </>
        ) : (
          <div className="text-embed mt-8">
            <MediumText>
              Still not visible? <Link onClick={openCrisp}>Contact us</Link>
            </MediumText>
          </div>
        )}
      </div>
    </Card>
  ) : (
    <Card>
      <SkeletonBodyText lines={4} />
    </Card>
  );
}

export default memo(EmbedApp);
